import { combineEpics } from 'redux-observable';
import { onLoadPriceFilteringRulesDoneEpic } from './_epics/onLoadPriceFilteringRulesDoneEpic.epic';
import { onUpdatePriceFilteringRulesDoneEpic } from './_epics/onUpdatePriceFilteringRulesDoneEpic.epic';
import { onValidatePriceFilteringRulesDoneEpic } from './_epics/onValidatePriceFilteringRulesDoneEpic.epic';
import { validatePriceFilteringRulesEpic } from './_epics/validatePriceFilteringRules.epic';

export const controllerPriceFilteringRulesEpic = combineEpics(
  onLoadPriceFilteringRulesDoneEpic,
  onUpdatePriceFilteringRulesDoneEpic,
  onValidatePriceFilteringRulesDoneEpic,
  validatePriceFilteringRulesEpic,
);
